module.exports = __webpack_public_path__ + "static/image15-0267dec23375d636b59c28c2840cef8e.png";